module.exports = __webpack_public_path__ + "static/img/brand.348ab010.png";